module.exports = __webpack_public_path__ + "img/59.0f28964b.png";